import React from 'react'
import './admin-workflows.css'
import CardModal from '../CardModal/CardModal'
import TaskCard from '../TaskCard/TaskCard'
import {WorkflowDropDown} from '../WorkflowDropDown/WorkflowDropDown'
import {PageCover} from '../PageCover/PageCover'
import {ErrorPopup} from '../ErrorPopup/ErrorPopup'
import Axios from 'axios'
import NewLoadingScreen from '../NewLoadingScreen/NewLoadingScreen'
import { baseUrl } from '../assets/Animations'
import loadingping from '../img/loadingpin.svg'
import WorkflowChip2023 from '../AdminTasks/WorkflowChip2023/WorkflowChip2023'
import OnboardingCardModal2023 from '../OnboardingCardModal2023/OnboardingCardModal2023'
import {createTeacherOnboardingWorkflow} from './WorkflowModels'

const myToken = localStorage.getItem('token')
const myHeader = {
    headers: { Authorization: `Bearer ${myToken}` }
}

const TeacherWorkflows = (props) => {
    const [workflows, setWorkflows] = React.useState([])
    const [openWorkflowModal2023, setOpenWorkflowModal2023] = React.useState(false)
    const [error, setError] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [gettingWorkflows, setGettingWorkflows] = React.useState(false)

    React.useEffect(() => getWorkflows(), [])

    const getWorkflows = async () => {
        setGettingWorkflows(true)
        Axios.get(`${baseUrl}/onboarding`, myHeader)
        .then(response => {
            setWorkflows(response.data)
            setGettingWorkflows(false)
        })
        .catch(e => {
            setError({message: e.response.data, status: e.response.status})
        })
    }

    const deleteItem = (item) => {
        setWorkflows(prev => (prev.filter((todo) => todo.todoId !== item.todoId && todo)))
    }
    const updateItem = (item) => {
        setWorkflows(prev => (prev.map((todo) => todo.todoId === item.todoId ? item : todo)))
    }

    return (
        <div className="admin-task-page">
            <div className="main-todo-area-wide">
                <div className="new-workflow-drop-down">
                    <div className="create-new-workflow-btn" onClick={() => createTeacherOnboardingWorkflow(setLoading, setWorkflows, setOpenWorkflowModal2023)}>+ Onboard Teacher</div>
                </div>
                <div className="area-title">Teacher Onboarding</div>
                <div className="tasks-area-scroll just-scooch-it">
                    {gettingWorkflows && <img alt="getting-workflows-ping" className="loading-ping" src={loadingping} />}
                    {workflows.map(workflow => workflow.whichList === 'teacher' && <WorkflowChip2023 key={workflow.todoId} workflow={workflow} setOpenWorkflowModal2023={setOpenWorkflowModal2023} getNotesAboutModal={props.getNotesAboutModal} />)}
                </div>
            </div>
            {openWorkflowModal2023 && <OnboardingCardModal2023 openWorkflowModal2023={openWorkflowModal2023} setOpenWorkflowModal2023={setOpenWorkflowModal2023} deleteItem={deleteItem} updateItem={updateItem} setShowNotes={props.setShowNotes} />}
            {error && <ErrorPopup error={error} setError={setError}/>}
            {loading && <NewLoadingScreen logo="favicon.png" message={loading} />}
        </div>
    )
}


export default TeacherWorkflows